<button *appRole="['Propiedades.Crear']" mat-raised-button color="primary" class="btn-nuevo" [routerLink]="['/propiedades/nuevo']">
    <mat-icon>add</mat-icon>
    Nueva propiedad
</button>
